import request from '../request'
/**
 *  获取所有的权限
 * @method getAllPermission
 * @return {[type]}         [description]
 */

//查询配置
export function searchwebConfig() {
    return request({
        url: `web/sys-web-config/front`,
        method: 'get',
    })
}

//新增或者修改配置
export function syswebConfig(form) {
    return request({
        url: `web/sys-web-config/system`,
        method: 'post',
        data: form,
    })
}